import type { DictDetailDtoObject, LmCategoryVo } from "types/openapi/lm";
import { defineStore } from "pinia";
import { getUnit } from "@/api/alliance";
import { getCategoryTree } from "@/api/app";

interface ICommonStore {
  categoryList: LmCategoryVo[];
  unitList: DictDetailDtoObject[];
  specsOptions: {
    label: string;
    value: number;
  }[];
}

export const useCommonStore = defineStore("common", () => {
  const store: ICommonStore = reactive({
    categoryList: [],
    unitList: [],
    specsOptions: [
      {
        label: "g",
        value: 0,
      },
      {
        label: "kg",
        value: 1,
      },
      {
        label: "斤",
        value: 2,
      },
    ],
  });
  function getSpecsNameByValue(value: number | undefined) {
    if (Number.isNaN(value)) {
      return "";
    }
    return store.specsOptions.find((item) => item.value === value)?.label;
  }
  function getUnitNameByValue(value: number | undefined) {
    if (Number.isNaN(value)) {
      return "";
    }
    return store.unitList.find((item) => item.code === value)?.name;
  }
  function getShowUnit({
    unit,
    weight,
    weightUnit,
  }: {
    unit: number;
    weight: number;
    weightUnit: number;
  }) {
    const unitName = getUnitNameByValue(unit);
    const weightUnitName = getSpecsNameByValue(weightUnit);
    return `${weight ?? ""}${weightUnitName ?? ""}${weightUnitName ? "/" : ""}${unitName ?? ""}`;
  }
  function getSpecsOptions() {
    return store.specsOptions;
  }

  async function GetCategoryTree(needRefresh: boolean = false) {
    if (store.categoryList.length && !needRefresh) {
      return store.categoryList;
    }
    const res = await getCategoryTree();
    store.categoryList = res?.data?.data || [];
    return store.categoryList;
  }
  async function getUnitList() {
    const res = await getUnit();
    store.unitList = res?.data?.data || [];
    return store.unitList;
  }
  function clear() {
    store.categoryList = [];
  }
  // 整理类目名
  function formatCategoryName(list) {
    return [list?.[2]?.categoryName, list?.[3]?.categoryName]
      .filter(Boolean)
      .join("-");
  }
  return {
    ...toRefs(store),
    GetCategoryTree,
    getUnitList,
    clear,
    getSpecsOptions,
    getSpecsNameByValue,
    getUnitNameByValue,
    getShowUnit,
    formatCategoryName,
  };
});
